import { createSlice } from "@reduxjs/toolkit";
import { initialStateProps } from '../interfaces/transaction';

const initialState : initialStateProps = {
    transactionConfirmation: {
        fetching: "unknown",
        error: ""
    },
    rejectInspection: {
        fetching: "unknown",
        error: ""
    }
}

const transactionSlice = createSlice({
    name: "transaction",
    initialState,
    reducers: {
        postTransactionConfirmationRequest: (state) => {
            state.transactionConfirmation.fetching = "loading";
        },
        postTransactionConfirmationSuccess: (state) => {
            state.transactionConfirmation.fetching = "success";
        },
        postTransactionConfirmationFailure: (state, action) => {
            state.transactionConfirmation.fetching = "failure";
            state.transactionConfirmation.error = action.payload;
        },
        rejectInspectionRequest: (state) => {
            state.rejectInspection.fetching = "loading";
        },
        rejectInspectionSuccess: (state) => {
            state.rejectInspection.fetching = "success";
        },
        rejectInspectionFailure: (state, action) => {
            state.rejectInspection.fetching = "failure";
        },
        cleanTransaction: (state) => {
            state.transactionConfirmation = initialState.transactionConfirmation;
        },
        cleanRejectInspection: (state) => {
            state.rejectInspection = initialState.rejectInspection;
        },
    }
})

export const {
    postTransactionConfirmationRequest,
    postTransactionConfirmationSuccess,
    postTransactionConfirmationFailure,
    rejectInspectionRequest,
    rejectInspectionSuccess,
    rejectInspectionFailure,
    cleanTransaction,
    cleanRejectInspection
} =
    transactionSlice.actions;

export default transactionSlice.reducer;